import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Share2, ChevronDown } from 'lucide-react';
import { MetaTags } from '../../../../components/SEO/MetaTags';
import { RelatedBlogPosts } from '../../../../components/Blog/RelatedBlogPosts';
export function BlogPostCovertNarcissistKO() {
  const articleData = {
    title: '당신의 전 애인은 내현적 나르시시스트입니까? (텍스트는 거짓말을 하지 않습니다)',
    description: '전 애인이 내현적 나르시시스트인지 궁금하십니까? 저희 AI가 문자 메시지에서 즉시 감지하는 7가지 미묘한 조작 행동을 발견하세요.',
    slug: 'is-your-ex-a-covert-narcissist',
    publishDate: '2025-03-08',
    author: 'Toxic Detector 편집팀'
  };
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [{
      '@type': 'Question',
      name: '내현적 나르시시스트란 무엇이며 외현적 나르시시스트와 어떻게 다릅니까?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '내현적 나르시시스트는 명백하고 외현적인 나르시시스트와 달리 매력, 미묘한 감정적 전술, 수동적 공격적인 메시지 뒤에 조작적인 행동을 숨깁니다.'
      }
    }, {
      '@type': 'Question',
      name: 'AI가 문자 메시지에서 내현적 나르시시즘을 감지할 수 있습니까?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '네. Toxic Detector는 어조, 죄책감 유발, 러브 바밍 주기, 불일치 및 정서적 조작 패턴을 분석하여 내현적 나르시시스트 행동을 표시합니다.'
      }
    }, {
      '@type': 'Question',
      name: '텍스트에서 내현적 나르시시스트의 일반적인 행동은 무엇입니까?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '정서적 조작, 가스라이팅, 수동적 공격적인 댓글, 피해자 코스프레, 러브 바밍 후 철수, 미묘한 통제 등입니다.'
      }
    }, {
      '@type': 'Question',
      name: '내현적 나르시시스트로부터 자신을 보호하려면 어떻게 해야 합니까?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '메시지를 기록하고, 직감을 믿고, 경계를 유지하고, Toxic Detector와 같은 도구를 사용하여 조작적인 패턴을 객관적으로 식별하십시오.'
      }
    }]
  };
  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: articleData.title,
    description: articleData.description,
    image: 'https://toxicdetector.com/images/logo.png',
    author: {
      '@type': 'Person',
      name: articleData.author
    },
    datePublished: articleData.publishDate,
    url: `https://toxicdetector.com/ko/blog/${articleData.slug}`
  };
  const handleShare = async () => {
    try {
      await navigator.share({
        title: articleData.title,
        text: articleData.description,
        url: 'https://toxicdetector.com/'
      });
    } catch (err) {
      navigator.clipboard.writeText('https://toxicdetector.com/');
      alert('링크가 클립보드에 복사되었습니다!');
    }
  };
  return <>
      <MetaTags title="당신의 전 애인은 내현적 나르시시스트입니까? AI가 조작을 감지하는 방법 | ToxicDetector" description="전 애인이 내현적 나르시시스트인지 궁금하십니까? 저희 AI가 즉시 감지하는 7가지 미묘한 조작 행동을 발견하세요." keywords="내현적 나르시시스트 징후, 숨겨진 나르시시스트 행동, 나르시시스트 조작 텍스트, AI 나르시시스트 탐지기" canonical={`https://toxicdetector.com/ko/blog/${articleData.slug}`} ogType="article" ogImage="https://cdn.magicpatterns.com/uploads/eYBGg4SniMpbkGoP3a2Uyt/file_00000000bb6072439a9d5e3820051ce3.png" schema={[faqSchema, articleSchema]} data-id="element-7801" data-mp="13ebdc29yklg" />
      <div className="flex flex-col w-full min-h-screen bg-gradient-to-b from-stone-50 to-white" data-id="element-7802" data-mp="2uvplmo3eatdz">
        <header className="bg-white/90 border-b border-gray-200 sticky top-0 z-50 backdrop-blur-sm" data-id="element-7803" data-mp="2py796nq65w18">
          <div className="max-w-3xl mx-auto px-6 py-4" data-id="element-7804" data-mp="33xgrbsxxr07u">
            <div className="flex items-center justify-between" data-id="element-7805" data-mp="2zualunindd2f">
              <Link to="/" className="text-2xl font-bold tracking-tight text-gray-900" data-id="element-7806" data-mp="2zwwqaea8rcgf">
                🚩 ToxicDetector
              </Link>
              <button onClick={handleShare} className="p-2.5 hover:bg-gray-50 rounded-lg transition-colors" aria-label="기사 공유" data-id="element-7807" data-mp="38t4btv1h3570">
                <Share2 size={20} className="text-gray-600" data-id="element-7808" data-mp="3in4s8t27fwv1" />
              </button>
            </div>
          </div>
        </header>

        <article className="max-w-3xl mx-auto w-full px-6 py-12" data-id="element-7809" data-mp="3rlzz87d2paze">
          <Link to="/blog" className="inline-flex items-center text-gray-600 text-sm mb-10 hover:text-gray-900 transition-colors group" data-id="element-7810" data-mp="3rjn7j2hijm95">
            <ArrowLeft size={16} className="mr-2 group-hover:-translate-x-1 transition-transform" data-id="element-7811" data-mp="1uucc750uak63" />
            블로그로 돌아가기
          </Link>

          <header className="mb-12" data-id="element-7812" data-mp="23o795prt54an">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight leading-tight text-gray-900" data-id="element-7813" data-mp="23n5tt93rdvn4">
              {articleData.title}
            </h1>
            <div className="flex items-center text-gray-600 text-sm gap-3" data-id="element-7814" data-mp="1bvztoso1fxxu">
              <time dateTime={articleData.publishDate} data-id="element-7815" data-mp="1fymmavsj9mw3">
                {new Date(articleData.publishDate).toLocaleDateString('ko-KR', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
              </time>
              <span className="text-gray-300" data-id="element-7816" data-mp="2rfw47dw0k6va">•</span>
              <span data-id="element-7817" data-mp="2wbbho4q400r6">{articleData.author}</span>
            </div>
          </header>

          <div className="mb-12" data-id="element-7818" data-mp="36gt9r5wccaea">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/eAKNBAYBhED67QeywsaDY6/1763120946474.jpg" alt="AI를 사용하여 내현적 나르시시스트 조작 징후에 대해 문자 메시지를 분석하는 여성" className="w-full rounded-2xl shadow-sm border border-gray-200" data-id="element-7819" data-mp="36frwcururbte" />
          </div>

          <div className="bg-white rounded-xl p-6 border border-gray-200 mb-12" data-id="element-7820" data-mp="2sowj76abm8k0">
            <h2 className="font-bold text-lg mb-4 text-gray-900" data-id="element-7821" data-mp="2nquzqk8zg780">목차</h2>
            <ul className="space-y-3 text-sm" data-id="element-7822" data-mp="2iqfpi1jzzfu9">
              <li data-id="element-7823" data-mp="2ipntwqqehi3z">
                <a href="#emotional-manipulation" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-7824" data-mp="2itbn1orxo2i6">
                  <span className="text-gray-400" data-id="element-7825" data-mp="29sn90u2ji25a">→</span> 1. 모든 메시지에서의
                  정서적 조작
                </a>
              </li>
              <li data-id="element-7826" data-mp="7ye9oqnxnnpj">
                <a href="#gaslighting" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-7827" data-mp="7zz3ge2fb2mc">
                  <span className="text-gray-400" data-id="element-7828" data-mp="268wgnliqhuds">→</span> 2. 서서히 구축되는
                  가스라이팅
                </a>
              </li>
              <li data-id="element-7829" data-mp="1sijczvcvl1u9">
                <a href="#passive-aggressive" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-7830" data-mp="1seviasvp29dy">
                  <span className="text-gray-400" data-id="element-7831" data-mp="2k8xjv7mh1dwf">→</span> 3. 수동적 공격적인
                  댓글
                </a>
              </li>
              <li data-id="element-7832" data-mp="2b7g821g3jydj">
                <a href="#playing-victim" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-7833" data-mp="2b7zdiiok8uao">
                  <span className="text-gray-400" data-id="element-7834" data-mp="zsau21aimdem">→</span> 4. 끊임없이 피해자
                  코스프레
                </a>
              </li>
              <li data-id="element-7835" data-mp="14rnmd1k5ocol">
                <a href="#love-bombing" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-7836" data-mp="14sysh812pwiv">
                  <span className="text-gray-400" data-id="element-7837" data-mp="s7qfc3sx0ywc">→</span> 5. 러브 바밍 후 철수
                </a>
              </li>
              <li data-id="element-7838" data-mp="167896xl2j2ck">
                <a href="#hidden-control" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-7839" data-mp="167rpk9v2lioh">
                  <span className="text-gray-400" data-id="element-7840" data-mp="dkf2zzowtav6">→</span> 6. 숨겨진 통제 및
                  감시
                </a>
              </li>
              <li data-id="element-7841" data-mp="8iy3o8m2pwgp">
                <a href="#inconsistent-tone" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-7842" data-mp="n9f4bpqvwicj">
                  <span className="text-gray-400" data-id="element-7843" data-mp="3qys7sllb4a7r">→</span> 7. 채널 간 일관성
                  없는 어조
                </a>
              </li>
            </ul>
          </div>

          <div className="prose prose-lg max-w-none" data-id="element-7844" data-mp="3lz5t07ptylwu">
            <p className="text-xl mb-8 leading-relaxed text-gray-700" data-id="element-7845" data-mp="30gvx9622u31e">
              전 애인이 매력적이고 배려심 깊은 척하면서 뒤에서 당신을 조작하고
              있다고 느낀 적이 있나요? 그것은{' '}
              <strong data-id="element-7846" data-mp="35hjn3oekkdu1">내현적 나르시시스트의 전형적인 징후</strong>입니다. 명백한
              나르시시스트와 달리, 내현적 나르시시스트는 미묘한 감정적 전술 뒤에
              조작을 숨깁니다.
            </p>
            <p className="mb-12 text-lg leading-relaxed text-gray-600" data-id="element-7847" data-mp="3fdwq5cw0841g">
              저희 <strong data-id="element-7848" data-mp="3jf8b353xo13b">AI는 숨겨진 조작을 감지</strong>하고 텍스트를
              분석하는 것만으로 즉시 식별합니다. 방법은 다음과 같습니다.
            </p>

            <section id="emotional-manipulation" className="mb-12" data-id="element-7849" data-mp="3odt6mr88pwlf">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-7850" data-mp="3obyn9hcmacjg">
                1️⃣ 모든 메시지에서의 정서적 조작
              </h2>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-7851" data-mp="1z04ldlp0mcf">
                내현적 나르시시스트는 자신의 뜻대로 하기 위해 감정을 비드립니다.
              </p>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-7852" data-mp="6vqj3whun9vq">
                <p className="italic text-gray-700 text-lg" data-id="element-7853" data-mp="azolcg2h10t0">
                  "네가 이것 때문에 화를 내다니 믿을 수가 없어..."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-7854" data-mp="1rfcdg9z4d9yk">
                AI는 일상적인 메시지에 숨겨진 미묘한 죄책감 유발과 정서적 압박을
                감지합니다.
              </p>
            </section>

            <section id="gaslighting" className="mb-12" data-id="element-7855" data-mp="1hhy1ono559cl">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-7856" data-mp="1hjivgb2mso9e">
                2️⃣ 서서히 구축되는 가스라이팅
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-7857" data-mp="2a6lrmwju4mwh">
                <p className="italic text-gray-700 text-lg" data-id="element-7858" data-mp="25fn5hgc60ulb">
                  "넌 그걸 잘못 기억하고 있어..."
                </p>
              </div>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-7859" data-mp="20fin1krp5psg">
                내현적 나르시시스트는 당신이 자신의 기억을 의심하게 만듭니다.
                AI는 현실이 왜곡되는 반복적인 사례를 표시합니다.
              </p>
            </section>

            <section id="passive-aggressive" className="mb-12" data-id="element-7860" data-mp="2t4fz365beqcr">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-7861" data-mp="2jbdzu9zssyqd">
                3️⃣ 수동적 공격적인 댓글
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-7862" data-mp="2eedrttje1lwm">
                <p className="italic text-gray-700 text-lg" data-id="element-7863" data-mp="2tav1mgbxish2">
                  "그래, 네가 행복하다면 뭐든..."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-7864" data-mp="2odd2fhnprrm9">
                수동적 공격성은 내현적 나르시시즘의 특징입니다. AI는 비꼬는 말,
                은밀한 비방, 숨겨진 적대감을 인식합니다.
              </p>
            </section>

            <section id="playing-victim" className="mb-12" data-id="element-7865" data-mp="2x9ucsio97lgy">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-7866" data-mp="3c01omfjra68o">
                4️⃣ 끊임없이 피해자 코스프레
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-7867" data-mp="373ujgoz6oyrs">
                <p className="italic text-gray-700 text-lg" data-id="element-7868" data-mp="3kywu1pez7cax">
                  "내가 널 위해 한 모든 것에도 불구하고..."
                </p>
              </div>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-7869" data-mp="3jn9jxgbwrsx">
                내현적 나르시시스트는 종종 비난을 뒤집어 자신을 피해자로
                만듭니다. AI는 당신에게 죄책감을 느끼게 하거나 사과를 강요하도록
                고안된 문구를 감지합니다.
              </p>
            </section>

            <section id="love-bombing" className="mb-12" data-id="element-7870" data-mp="3qpeach5gy8tw">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-7871" data-mp="3vlbku6u1wkyr">
                5️⃣ 러브 바밍 후 철수
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-7872" data-mp="3gvdtxj4qlh5v">
                <p className="italic text-gray-700 text-lg" data-id="element-7873" data-mp="3lpi5ygsv0fdt">
                  "넌 내가 사랑한 유일한 사람이야 😢" → 잠수
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-7874" data-mp="3bxvvwns9cmcn">
                강렬한 애정 표현 후 정서적 거리를 두는 이 고전적인 주기는 위험
                신호입니다. AI는 여러 채팅에 걸쳐 이러한 패턴을 식별합니다.
              </p>
            </section>

            <section id="hidden-control" className="mb-12" data-id="element-7875" data-mp="32wnx84ltxji1">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-7876" data-mp="18hh2tyj1wt83">
                6️⃣ 숨겨진 통제 및 감시
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-7877" data-mp="13qioh4hmi57h">
                <p className="italic text-gray-700 text-lg" data-id="element-7878" data-mp="zodvm7z01clw">
                  "그냥 확인하는 거야... 또"
                </p>
              </div>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-7879" data-mp="urx6bag2cs78">
                관심으로 가장한 미묘한 통제는 은밀한 전술입니다. AI는 명백한
                공격성 없이 반복적인 확인 행동을 표시합니다.
              </p>
            </section>

            <section id="inconsistent-tone" className="mb-12" data-id="element-7880" data-mp="1nfjbuo8uq6wq">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-7881" data-mp="1ielu2crr7evr">
                7️⃣ 채널 간 일관성 없는 어조
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-7882" data-mp="1diocy48o24hx">
                <p className="italic text-gray-700 text-lg" data-id="element-7883" data-mp="71t0qxjbeidl">
                  단체 채팅: 장난기 / 1:1: 비판적
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-7884" data-mp="3o3e44zzyf16i">
                내현적 나르시시스트는 종종 공개적으로는 행동을 숨기고 사적으로는
                조작합니다. AI는 대화를 비교하여 불일치를 강조합니다.
              </p>
            </section>

            <section className="mb-12" data-id="element-7885" data-mp="1v4j1fx2pjmf">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-7886" data-mp="1ucuuq5t2o66">
                🛡 자신을 보호하는 방법
              </h2>
              <div className="bg-white rounded-xl border border-gray-200 p-6" data-id="element-7887" data-mp="anzn46at19am">
                <ul className="space-y-3 text-lg text-gray-600" data-id="element-7888" data-mp="aq2b6ksecscp">
                  <li className="flex items-start gap-3" data-id="element-7889" data-mp="flrd2urw2lc6">
                    <span className="text-purple-600 font-bold" data-id="element-7890" data-mp="kmf59jrut87z">•</span>
                    <span data-id="element-7891" data-mp="kk2mj4e9uttv">직감을 믿으세요. 위험 신호를 무시하지 마세요.</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-7892" data-mp="pkqg9xtvxors">
                    <span className="text-purple-600 font-bold" data-id="element-7893" data-mp="2me2241yffxcd">•</span>
                    <span data-id="element-7894" data-mp="2rclmvz1ab335">명확성을 위해 스크린샷을 보관하세요.</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-7895" data-mp="2rcvajfyuwy5o">
                    <span className="text-purple-600 font-bold" data-id="element-7896" data-mp="lnjim44al7ak">•</span>
                    <span data-id="element-7897" data-mp="gpi31t62rq3u">친구 나 치료사와 경험을 공유하세요.</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-7898" data-mp="grcd2cft5xt5">
                    <span className="text-purple-600 font-bold" data-id="element-7899" data-mp="uny9dj00zelg">•</span>
                    <span data-id="element-7900" data-mp="ppelhd1vfsqg">
                      Toxic Detector와 같은 도구를 사용하여 패턴을 식별하세요.
                    </span>
                  </li>
                </ul>
              </div>
            </section>

            <section className="mb-12" data-id="element-7901" data-mp="3u4eaypngr9ae">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-7902" data-mp="3u5pi8zg4az69">
                💀 자신의 눈으로 확인하세요
              </h2>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-7903" data-mp="brzonn9agiog">
                내현적 나르시시즘은 발견하기 어려울 수 있지만 AI는 놓치지
                않습니다. 채팅을 업로드하고 즉시 분석을 받으세요:
              </p>
              <div className="bg-white border border-gray-200 rounded-xl p-6 mb-6" data-id="element-7904" data-mp="3fd5fhzwvqtpc">
                <p className="text-gray-900 font-bold text-center text-lg" data-id="element-7905" data-mp="3afvj20b2phs0">
                  "🚩 78% 조작 감지. 은밀한 전술 식별됨!"
                </p>
              </div>
            </section>

            <section id="faq" className="mb-12" data-id="element-7906" data-mp="1upmkcgwwgorf">
              <h2 className="text-3xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-7907" data-mp="1gxett6w7lu16">
                자주 묻는 질문
              </h2>
              <div className="space-y-4" data-id="element-7908" data-mp="1lvq39gile2iv">
                {faqSchema.mainEntity.map((faq, index) => <details key={index} className="bg-white rounded-xl border border-gray-200 overflow-hidden group" data-id="element-7909" data-mp="29n58bh1r6xxt" data-mpi={index}>
                    <summary className="px-6 py-4 cursor-pointer font-semibold text-base text-gray-900 hover:bg-gray-50 transition-colors flex items-center justify-between" data-id="element-7910" data-mp="1zo65if3o5wiq">
                      <span data-id="element-7911" data-mp="24ou01ar3wvhp">{faq.name}</span>
                      <ChevronDown size={20} className="text-gray-400 group-open:rotate-180 transition-transform" data-id="element-7912" data-mp="o7ppajkajbut" />
                    </summary>
                    <div className="px-6 pb-4 text-gray-600 leading-relaxed text-sm" data-id="element-7913" data-mp="94fxw3b34dth">
                      {faq.acceptedAnswer.text}
                    </div>
                  </details>)}
              </div>
            </section>
          </div>

          <div className="bg-purple-600 rounded-2xl p-10 text-center text-white mt-16" data-id="element-7914" data-mp="3rjywkqcvp6h6">
            <h2 className="text-3xl font-bold mb-4 tracking-tight" data-id="element-7915" data-mp="3mkm4nr75h97q">
              💀 진실을 밝힐 준비가 되셨나요?
            </h2>
            <p className="text-purple-100 mb-8 text-lg leading-relaxed max-w-2xl mx-auto" data-id="element-7916" data-mp="3hl163hvw72vj">
              추측은 그만하세요. 텍스트를 Toxic Detector에 업로드하고 즉시 독성
              점수를 받으세요. 저희 AI는 당신이 놓쳤을지도 모르는 은밀한 조작을
              드러냅니다.
            </p>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 mb-8 border border-white/20" data-id="element-7917" data-mp="38mfl7g2y7brl">
              <p className="font-bold text-xl" data-id="element-7918" data-mp="1brt5c3urj9t3">
                "🚩 78% 조작 감지. 은밀한 전술 식별됨!"
              </p>
            </div>
            <Link to="/signup" className="inline-block bg-white text-purple-600 px-10 py-4 rounded-lg font-bold text-lg hover:bg-gray-50 transition-colors" data-id="element-7919" data-mp="1ed0l4i87vqsf">
              지금 채팅 스캔하기 →
            </Link>
          </div>

          <RelatedBlogPosts posts={[{
          title: 'AI가 즉시 감지하는 가스라이팅 징후 7가지',
          description: 'AI가 텍스트 대화에서 감지하는 주요 가스라이팅 패턴을 알아보세요.',
          slug: '7-signs-of-gaslighting',
          emoji: '💀'
        }, {
          title: '수동적 공격적인 텍스트에 대한 궁극적인 가이드',
          description: '문자 메시지에서 수동적 공격적인 행동과 숨겨진 조작을 발견하세요.',
          slug: 'passive-aggressive-texts-guide',
          emoji: '😤'
        }]} data-id="element-7920" data-mp="1o3c1x5d01ugq" />

          <div className="mt-12 text-center" data-id="element-7921" data-mp="2gqg0osli1ck2">
            <button onClick={handleShare} className="inline-flex items-center text-gray-600 hover:text-gray-900 font-medium transition-colors text-sm" data-id="element-7922" data-mp="2gtu0bt2s37nt">
              <Share2 size={18} className="mr-2" data-id="element-7923" data-mp="36sigqakfw5hc" />이 기사 공유하기
            </button>
          </div>
        </article>

        <footer className="bg-white border-t border-gray-200 py-12 mt-16" data-id="element-7924" data-mp="3gkfvtsekjhlc">
          <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-7925" data-mp="3gmix58l68x5d">
            <p className="text-gray-500 text-sm" data-id="element-7926" data-mp="3bsofeap4ms8x">
              © {new Date().getFullYear()} ToxicDetector. 판권 소유.
            </p>
          </div>
        </footer>
      </div>
    </>;
}